import Swal from 'sweetalert2';
import { changeAccessToken, changeUserDetail, changeUserInfo } from '../../store/user';
import { createFetch } from '../../utils';
import lang from '../../lang';

export const registerAccessToken = (accessToken, expiredAt = new Date().getTime() + (3600 * 2000)) => ({
    type: changeAccessToken,
    payload: {
        accessToken,
        expiredAt,
    },
});

export const getUserDetail = async (accessToken) => {
    const result = await createFetch({
        accessToken,
        method: 'GET',
        path: 'users/me',
    });
    if (result.status === 200) {
        return {
            type: changeUserDetail,
            payload: {
                info: result.userInfo,
                profileItems: result.userProfile.item,
                profile: result.userProfile,
            },
        };
    }
    Swal.fire({
        title: lang.titleError,
        text: lang.serverMessage[result.message] || result.message,
    });
    return {
        type: 'LOGOUT',
    };
};

export const updateUserInfo = userInfo => ({
    type: changeUserInfo,
    payload: userInfo,
});

export default null;
